var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNextjsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 210.59 210.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1e1b19;}.cls-2{fill:#e9a18b;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 37") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_27",
    "data-name": "Layer 27"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 105.29,
    cy: 105.29,
    r: 105.29
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M75.83,66.19a3.12,3.12,0,0,0-.44,0H69a3.09,3.09,0,0,0-3.09,3.09v81.83A3.08,3.08,0,0,0,69,154.14h6.42a3.08,3.08,0,0,0,3.09-3.08V89.54L153.17,199.1a104.6,104.6,0,0,0,9.2-5.31L78.71,67.52A3.1,3.1,0,0,0,75.83,66.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M140.37,63.27H134a3.08,3.08,0,0,0-3.09,3.08v54.9l12.6,19.37V66.35A3.09,3.09,0,0,0,140.37,63.27Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextjsIcon);
export default __webpack_public_path__ + "static/media/Nextjs--icon.76af863509af149b316a37c7a3e3df1d.svg";
export { ForwardRef as ReactComponent };